/**
 * Partner (IB) login site — Log In button, email verification CTA, etc.
 * Override with REACT_APP_PARTNER_LOGIN_URL (no trailing slash).
 */
export const PARTNER_LOGIN_ORIGIN = (
  process.env.REACT_APP_PARTNER_LOGIN_URL ||
  "http://partner-login.itradepro.godocm.com"
).replace(/\/$/, "");

/** Typical entry path if the portal expects /login/ */
export const PARTNER_LOGIN_URL = `${PARTNER_LOGIN_ORIGIN}/login/`;
